export default {
  title: 'Abonnement starten',
  title_confirm: 'Plan bestätigen',
  step: 'Schritt {{current}} von {{total}}',
  subtitle: '{{name}} · 1 Standort',
  trial_badge: '{{days}} Tage kostenlos',
  trial_headline: 'Die ersten {{days}} Tage kostenlos',
  then_price: 'Danach {{price}} / Monat pro Standort · inkl. anfallender Steuer',
  price_per_month: '{{price}} / Monat',
  price_terms: 'Pro Standort, monatliche Abrechnung · inkl. anfallender Steuer',
  tier_upsell:
    'Ab {{threshold}} Live-Standorten sinkt der Preis für alle Ihre Standorte automatisch auf {{price}} / Monat pro Standort.',
  tier_active: 'Mengenpreis — ab {{threshold}} Live-Standorten',
  due_today: 'Heute fällig',
  from_date: 'Ab {{date}}',
  no_charge_today: 'Heute wird nichts abgebucht.',
  no_charge_until: 'Heute wird nichts abgebucht. Kündigen Sie bis zum {{date}}, zahlen Sie nichts.',
  active: '{{plan}} ist für dieses Restaurant aktiv.',
  active_with_trial: '{{plan}} ist für dieses Restaurant aktiv, kostenlos bis {{date}}.',
  terms:
    'Ich stimme den <a href="{{terms_url}}" target="_blank" rel="noreferrer">FoodAmigos Partner-Plattform-Bedingungen</a> zu, einschließlich Aktivierung, Kündigung und Rückerstattung.',
  error: 'Der Kauf konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
  loading: 'Der Plan dieses Restaurants wird geprüft …',
  load_error: 'Der Plan dieses Restaurants konnte nicht geprüft werden.',
  unavailable:
    'Dieses Produkt ist für dieses Restaurant nicht verfügbar. Bitte wenden Sie sich an Ihren FoodAmigos Account Manager.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Online-Bestellung',
          description: 'Direktbestellungen auf der eigenen Marken-Website des Restaurants',
        },
        reservations: {
          title: 'Tischreservierung',
          description: 'Gäste reservieren ihren Tisch direkt online',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Angebots-Builder, Treuepunkte-Programm und KI-Antworten auf Google-Bewertungen',
        },
        pricing: {
          title: '0 % Provision, keine Einrichtungsgebühr',
          description: 'Eine Lizenz pro Standort, monatliche Abrechnung',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'Die eigene Marken-App des Restaurants',
          description: 'Im App Store und bei Google Play',
        },
        engagement: {
          title: 'Push-Benachrichtigungen und Treueprogramm',
          description: 'Gäste mit Angeboten und Punkten zurückholen',
        },
        ordering: {
          title: 'Bestellungen ohne Provision',
          description: 'Direktbestellungen direkt aus der App',
        },
        apple: {
          title: 'Apple-Developer-Account erforderlich',
          description: '99 $/Jahr, zahlbar an Apple, auf die Firma des Restaurants',
        },
      },
    },
    ai_website: {
      title: 'Website-Builder-Abonnement',
      subtitle_domain: 'Bringen Sie die Website von {{name}} auf {{domain}} live',
      features: {
        domain: {
          title: 'Ihre Website, live auf Ihrer eigenen Domain',
          description: 'Die Marken-Website des Restaurants',
        },
        ai: {
          title: 'Mit KI erstellt und aktualisiert',
          description: 'Seiten, Texte und Bilder für das Restaurant in wenigen Minuten erstellen',
        },
        ordering: {
          title: 'Bestellung und Reservierung inklusive',
          description: 'Gäste bestellen und reservieren direkt auf der Website',
        },
        pricing: {
          title: 'Keine Einrichtungsgebühr',
          description: 'Eine Lizenz pro Standort, monatliche Abrechnung',
        },
      },
    },
    storefront: {
      title: 'Website-Builder-Abonnement',
      subtitle_domain: 'Bringen Sie die Website von {{name}} auf {{domain}} live',
      features: {
        domain: {
          title: 'Ihre Website, live auf Ihrer eigenen Domain',
          description: 'Die Marken-Website des Restaurants',
        },
        ai: {
          title: 'Mit KI erstellt und aktualisiert',
          description: 'Seiten, Texte und Bilder für das Restaurant in wenigen Minuten erstellen',
        },
        ordering: {
          title: 'Bestellung und Reservierung inklusive',
          description: 'Gäste bestellen und reservieren direkt auf der Website',
        },
        pricing: {
          title: 'Keine Einrichtungsgebühr',
          description: 'Eine Lizenz pro Standort, monatliche Abrechnung',
        },
      },
    },
  },
  payment_method: {
    label: 'Ihre Partner-Zahlungsmethode',
    on_file: 'Hinterlegte Karte',
    pending_title: 'Ihre Zahlungsmethode wird bestätigt',
    pending: 'Stripe bestätigt die soeben hinzugefügte Karte noch. Das kann eine Minute dauern.',
    still_pending: 'Noch nicht eingegangen. Bitte warten Sie einen Moment und prüfen Sie es erneut.',
    error: 'Das Zahlungsformular konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',
  },
  buttons: {
    close: 'Schließen',
    continue_to_payment: 'Weiter zur Zahlung',
    start_trial: '{{days}} Tage kostenlos testen',
    subscribe: 'Abonnement starten',
    continue: 'Weiter',
    change: 'Ändern',
    retry: 'Erneut versuchen',
    check_again: 'Erneut prüfen',
    add_again: 'Karte erneut hinzufügen',
  },
};
